export const faqs = [
  {
    id: "faq-1",
    q: "美容医療が初めてでも相談できますか？",
    a: "はい。初めての方も多くご来院いただいています。カウンセリングでお悩みやご希望を伺い、施術内容や料金について分かりやすくご説明しますので、ご安心ください。",
  },
  {
    id: "faq-2",
    q: "カウンセリングだけでも大丈夫ですか？",
    a: "問題ありません。施術を決めていない段階でのご相談も歓迎しています。ご納得いただいたうえで、治療を選んでいただけます。",
  },
  {
    id: "faq-3",
    q: "当日に施術できますか？",
    a: "内容によっては当日施術が可能です。混雑状況やご希望の施術によって異なりますので、ご予約時にご相談ください。",
  },
  {
    id: "faq-4",
    q: "男性も利用できますか？",
    a: "はい、男性の方もご利用いただけます。メンズ医療脱毛をはじめ、お悩みに合わせてご提案します。",
  },
  {
    id: "faq-5",
    q: "支払い方法を教えてください。",
    a: "現金のほか、各種クレジットカード、一部の医療ローンに対応しています。詳しくはご来院時またはお問い合わせにてご案内します。",
  },
  {
    id: "faq-6",
    q: "未成年でも施術できますか？",
    a: "未成年の方は、保護者の同意が必要です。所定の同意書をご用意していますので、ご予約前にご確認ください。",
  },
  {
    id: "faq-7",
    q: "予約変更・キャンセルはできますか？",
    a: "前日までにご連絡いただければ承ります。LINEまたはお電話にてご連絡ください。",
  },
];